/**
 * 当前上下文
 */
import { store } from '../index'
import { history } from '../routes'
import Http from './Http'
import { UserContext } from '@models'

/**
 * Oauth ClientId
 */
const clientId = process.env.REACT_APP_CLIENT_ID
const clientSecret = process.env.REACT_APP_CLIENT_SECRET

/**
 * 获取 context
 */
const getContext = () => {
    return store.getState().ctx
}

/**
 * 获取 token
 */
const getToken = (): string => {
    return getContext().token
}

/**
 * 是否已登陆
 */
const getIsLogined = (): boolean => {
    return getContext().logined;
}

/**
 * 屏幕宽度
 */
const getScreenWidth = (): number => {
    return document.documentElement.clientWidth
}

/**
 * 屏幕高度
 */
const getScreenHeigh = (): number => {
    return document.documentElement.clientHeight
}

/**
 * 获取 PathVariable
 * @param props
 * @param paramName
 */
const getPathVar = (props: any, paramName?: string) => {
    if (!paramName) {
        paramName = 'id'
    }
    return props.match.params[paramName]
}

/**
 * 初始化用户上下文
 */
async function initUserContext() {
    let user = await Http.get<JSONObject>('/sys/users/self');

    let userCtx: UserContext = {
      ...user,
      logined: true,
      token: Context.getToken(),
      fullName: user.lastName,
      email: user.emailAddress,
    }

    dispatch({ type: 'ACTION_LOGIN', data: userCtx })
}

/**
 * 路由
 */
const route = (pathname: string) => {
    history.push(pathname)
}

/**
 * dispatch redux action
 * @param action
 */
const dispatch = (action: any) => {
    store.dispatch(action)
}

const Context = {
    clientId,
    clientSecret,
    initUserContext,
    getScreenWidth,
    getScreenHeigh,
    getContext,
    getToken,
    getIsLogined,
    route,
    dispatch,
    getPathVar,
}

export default Context
